import { defineComponent as _defineComponent } from 'vue'
import { apiGet, apiPost } from '@/store/api';
import { GlobalHelperFunctions } from '@/common/GlobalHelperFunctions';
import { computed, ref, watch } from 'vue';
import vuetify from '@/plugins/vuetify';
import GatCountryFlag from './GatCountryFlag.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GatVesselSelect',
  props: {
  value: [String, Number],
  size: String,
  label: String,
  required: Boolean,
  readonly: Boolean,
  disabled: Boolean,
  hint: String,
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;




const items = ref([]);
const model = ref<string | number | undefined>(undefined);

watch(
  () => props.value,

  (val) => {
    model.value = val;
  },
  {
    immediate: true,
  }
);

const isMobile = computed(() => vuetify.framework.breakpoint.xsOnly);

function formatNumber(value: any, format: any) {
  return GlobalHelperFunctions.formatNumber(value, format);
}
function getVesselFlag(flag: string) {
  if (flag) {
    return flag;
  }

  return '';
}

function getItems(searchText: string) {
  apiPost('helper/search/', { table: 'vessel', text: searchText }).then((data) => {
    items.value = data;
  });
}

function updateValue() {
  emit('input', model.value);
}

function itemNotFound(id: string | number) {
  apiGet(`helper/vessel/${id}`).then((data) => {
    items.value = data;
  });
}

function fadeEntry() {
  return false;
}

return { __sfc: true,props, emit, items, model, isMobile, formatNumber, getVesselFlag, getItems, updateValue, itemNotFound, fadeEntry, GatCountryFlag }
}

})